<template>
  <span
    :class="currentIcon" 
    v-bind="$props"
    :title="title"
    @click="click"
  />
</template>

<script>
export default {
    name: "PsIcon",
    props: {
        click: {
            type: Function,
            required: false,
            default: () => {}
        },
        mouseout: {
            type: Function,
            required: false,
            default: () => {}
        },
        icon: {
            type:String,
            required: true
        },
        additionalClasses: {
            type: String,
            required: false
        }, 
        title: {
            type: String, 
            required:false
        }
    },
    data() {
        return {
            icons: {
                save: "icon-saveDisk-24",
                add: "icon-plus-24", 
                refresh: "icon-Refresh_24",
                spread: "icon-ellipsis-24",
                search: "icon-search",
                close: "icon-close-24",
                arrow_back: "icon-back_arrow",
                upload:"icon-upload",
                excel:"icon-excel",
                check:"icon-check-24",
                cog:"icon-cog",
                copy:"icon-copy-24",
                pw_reset:"icon-pw_reset",
                import:"icon-import",
                recon:"icon-recon",
                delete:"icon-trash-24",
                freeze:"icon-freeze",
                freeze_bold:"icon-freeze_bold",
                freeze_left:"icon-freeze_left",
                freeze_both:"icon-freeze_both",
                freeze_top:"icon-freeze_top",
                play:"icon-play-24",
                toggle:"icon-toggle",
                menu: "icon-menu-24"
            }
        };
    },
    computed: {
        currentIcon: function(icon) {
            return this.icons[this.icon] + " " + this.additionalClasses;
        }
    },
    mounted()  {
   
        if (typeof(this.$parent) !== "undefined" && typeof(this.$parent.$vnode) != "undefined"){
            if(this.$parent.$vnode.tag.indexOf("PsColumn") >= 0)
            {
                this.$el.remove();
            }
        }
    }
};
</script>
<style>
@import "../styles/ps-icon.css";
</style>
